import Report from '../common/types/api/report'
import i18n from 'live/services/i18n'
import { get } from 'lodash'
import { Recipient } from '../common/types/form'

const MAIL_SETTINGS = 'mailSettings'

const reportRequiredFields = [
    `${MAIL_SETTINGS}.subject`,
    `${MAIL_SETTINGS}.channels`,
    `${MAIL_SETTINGS}.recipients`,
    'title'
]
export const reportValidator = (report: Report): string[] => {
    return reportRequiredFields.reduce((result, current) => {
        // TODO: cron " " is passing for the back-end and not showing error notification
        if (
            !get(report, current) ||
            !get(report, current)?.length ||
            (typeof get(report, current) === 'string' && !get(report, current).trim().length)
        ) {
            // cleanup
            const valueToClean = current.replace(`${MAIL_SETTINGS}.`, '')
            switch (valueToClean) {
                case 'channels':
                    result.push(i18n('SMTP Instance'))
                    break
                case 'subject':
                    result.push(i18n('Email Subject'))
                    break
                case 'title':
                    result.push(i18n('Instance Name'))
                    break
                case 'recipients':
                    result.push(i18n('Recipients'))
                    break
            }
        } else if (get(report, current)?.length && typeof get(report, current) === 'object') {
            const res = Object.entries(get(report, current)).reduce((recipRes, [, recipCurr]) => {
                const recipientForMoreValidations = { ...(recipCurr as Recipient) }
                if (Object.prototype.hasOwnProperty.call(recipientForMoreValidations, 'name')) {
                    if (!recipientForMoreValidations.name || !recipientForMoreValidations.name?.trim().length) {
                        recipRes = 'Recipients'
                    }
                }

                return recipRes
            }, '' as string)

            // including in 'global' list of fields
            if (res && !result.includes(res)) {
                result.push(res)
            }
        }

        return result
    }, [])
}

const fields = ['cron', 'subject', 'channels', 'title', 'recipients']
export const translateErrorBackendMessages = (errorResponse: string): string[] => {
    const messagePrefix = 'Invalid field: '
    console.error(errorResponse)

    const remainingErrosFields = fields.reduce((result, current) => {
        if (errorResponse.includes(current)) {
            switch (current) {
                case 'cron':
                    result.push(messagePrefix + 'Schedules Expression')
                    break
                case 'subject':
                    result.push(messagePrefix + 'Subject')
                    break
                case 'title':
                    result.push(messagePrefix + 'Title')
                    break
                case 'recipients':
                    result.push(errorResponse)
                    break
            }
        }

        return result
    }, [] as string[])

    if (!remainingErrosFields.length) {
        remainingErrosFields.push(`Error: ${errorResponse}`)
    }

    return remainingErrosFields
}

export const sleep = async (time: number): Promise<void> => {
    return new Promise(resolve => setTimeout(resolve, time))
}
